import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'policy.view.policy-details.',
        defaultMessage: '{policyType} {policyNumber} {status}'
    },
    currentTab: {
        id: 'policy.view.policy-details.tab.Current',
        defaultMessage: 'Current'
    },
    changePolicy: {
        id: 'policy.view.policy-details.Change Policy',
        defaultMessage: 'Change Policy'
    },
    renewalTab: {
        id: 'policy.view.policy-details.tab.Renewing',
        defaultMessage: 'Renewing'
    },
    DownloadIDCard: {
        id: 'policy.view.policy-details.Download ID Card',
        defaultMessage: 'Download ID Card'
    },
    policyCoveragesPnc: {
        id: 'policy.view.policy-details.Please view the policy packets in the Documents section below for complete information regarding coverages for this line of business.',
        defaultMessage: 'Please view the policy packets in the Documents section below for complete information regarding coverages for this line of business.'
    }
});
